import {
  ONBOARDING_STATUS,
  OPERATOR_SPECIALTY,
  FILING_STATUS,
} from '../types/db-types';

// Status colors for onboarding status
export const getOnboardingStatusColor = (
  status: ONBOARDING_STATUS
): { backgroundColor: string; color: string } => {
  switch (status) {
    case ONBOARDING_STATUS.ONBOARDING_STARTED:
      return { backgroundColor: '#E3F2FD', color: '#1565C0' }; // Light blue
    case ONBOARDING_STATUS.CALL_SCHEDULED:
      return { backgroundColor: '#FFF3E0', color: '#EF6C00' }; // Light orange
    case ONBOARDING_STATUS.CALL_ATTENDED:
      return { backgroundColor: '#F3E5F5', color: '#7B1FA2' }; // Light purple
    case ONBOARDING_STATUS.CONVERTED:
      return { backgroundColor: '#E8F5E8', color: '#2E7D32' }; // Light green
    case ONBOARDING_STATUS.NOT_INVESTING:
    case ONBOARDING_STATUS.NOT_VALID:
      return { backgroundColor: '#FFEBEE', color: '#C62828' }; // Light red
    default:
      return { backgroundColor: '#F5F5F5', color: '#616161' }; // Light grey
  }
};

// Specialty colors for operator specialty
export const getOperatorSpecialtyColor = (
  specialty: OPERATOR_SPECIALTY
): { backgroundColor: string; color: string } => {
  switch (specialty) {
    case OPERATOR_SPECIALTY.RETURNS:
      return { backgroundColor: '#E8F5E8', color: '#2E7D32' }; // Light green
    case OPERATOR_SPECIALTY.DEDUCTIONS:
      return { backgroundColor: '#E3F2FD', color: '#1565C0' }; // Light blue
    case OPERATOR_SPECIALTY.LIQUIDITY:
      return { backgroundColor: '#FFF3E0', color: '#EF6C00' }; // Light orange
    case OPERATOR_SPECIALTY.BALANCED_RETURNS_DEDUCTIONS:
      return { backgroundColor: '#F3E5F5', color: '#7B1FA2' }; // Light purple
    case OPERATOR_SPECIALTY.LOW_RISK:
      return { backgroundColor: '#E0F2F1', color: '#00695C' }; // Light teal
    default:
      return { backgroundColor: '#F5F5F5', color: '#616161' }; // Light grey
  }
};

// Filing status colors
export const getFilingStatusColor = (
  status: FILING_STATUS
): { backgroundColor: string; color: string } => {
  switch (status) {
    case FILING_STATUS.SINGLE:
      return { backgroundColor: '#E3F2FD', color: '#1565C0' }; // Light blue
    case FILING_STATUS.MARRIED_JOINT:
      return { backgroundColor: '#E8F5E8', color: '#2E7D32' }; // Light green
    case FILING_STATUS.MARRIED_SEPARATE:
      return { backgroundColor: '#FFF3E0', color: '#EF6C00' }; // Light orange
    case FILING_STATUS.HEAD_HOUSEHOLD:
      return { backgroundColor: '#F3E5F5', color: '#7B1FA2' }; // Light purple
    default:
      return { backgroundColor: '#F5F5F5', color: '#616161' }; // Light grey
  }
};
